import React, { useContext, useEffect } from 'react'
import {Button} from '../components/indexComponents';
import "../CSS/Home.css"
import { AuthContext } from '../App';
import { useNavigate } from 'react-router-dom';

function Home() {
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    if(isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLogout= () => {
    localStorage.removeItem('token');
  }

  return (
    <div className='home-frame'>
      <div className="home-header">
          <h1>Do Your Task</h1>
      </div>
      <div className="home-content">
        <Button route="/login" divClass="login-btn" type="" text="Se Connecter"/>
        <Button route="/signup" divClass="signup-btn" type="" text="Créer un compte"/>
        <button onClick={handleLogout}></button>
      </div>
    </div>
  )
}

export default Home;
